<template>
    <div class="card_back" :style="{backgroundColor:getSuccessCourseColor()}">
        <HeaderNav v-if="!isWeixinBrowser()" :navtitle="wordCard.word" :beforecolor="'#fff'" :backcolor="getSuccessCourseColor()"
                   @returnBack="goToBack"></HeaderNav>

        <div class="card_image">
            <div class="main_content">
                <img class="img_card" v-lazy="cardImg" @click="playAudio"/>
                <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/word_course_volume3.png" height="30" width="30"/>
                <audio :src="$qiNiuDomainBase + wordCard.audio" @ended="playEnded()" id="musicMp3" controls=""></audio>

                <div class="english_interpretation" v-if="!isEmpty(wordCard.chineseAndEnglishInterpretation)" @click="popupClick()">
                    <img src="@/assets/icon_english_english.png" height="15" width="15"/>
                    <span>中英解释</span>
                </div>
            </div>
        </div>
        <mt-popup
                v-model="popupVisible"
                popup-transition="popup-fade"
                class="popup_style">
            <div @click="closePopup">
                <pre>{{wordCard.chineseAndEnglishInterpretation}}</pre>
            </div>
        </mt-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                wordCardId: 0,
                wordCard: {},
                cardImg: "",
                popupVisible: false,
                isPlaying: false,
                tiemr: null
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            popupClick() {
                this.popupVisible = true;
            },
            closePopup:function() {
                this.popupVisible = false;
            },
            playAudio:function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');
                that.isPlaying = true;
                musicMp3.play();
            },
            playEnded() {
                this.isPlaying = false;
            },
        },
        beforeCreate() {
            let that = this;
            this.wordCardId = that.$route.query.wordId;

            let url = "success/getWordCard/" + that.wordCardId;
            that.$axios.get(url).then((response) => {
                that.wordCard = response.data;
                that.cardImg = that.$qiNiuDomainBase + that.wordCard.picture;

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    that.playAudio();
                }, 100);
            }).catch(function (error) {
                alert(error)
            });
        },
        mounted() {
            window.SWordCardScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.SWordCardScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.SWordCardScrollTop);
        },
    }
</script>

<style scoped>
    .card_back {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
    }

    .card_image {
        position: absolute;
        width: 100%;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .main_content {
        max-width: 560px;
        width: 100%;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        margin-top: 20px;
    }

    .main_content .img_card {
        width: calc(100% - 60px);
        margin-left: 30px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .main_content .img_play {
        position: absolute;
        right: 45px;
        top: 15px;
    }

    audio {
        display: none;
    }

    .english_interpretation {
        position: relative;
        float: right;
        margin-top: 5px;
    }

    .english_interpretation img {
        float: left;
        margin-top: 4px;
        margin-right: 5px;
    }

    .english_interpretation span {
        color: white;
        padding-right: 30px;
    }

    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap;           /* css-3 */
        white-space: -moz-pre-wrap;      /* Mozilla, since 1999 */
        white-space: -o-pre-wrap;        /* Opera 7 */
        word-wrap: break-word;           /* Internet Explorer 5.5+ */
    }

</style>